/** @namespace $route.current */
/** @namespace $route.current.params */
module.exports = ["$route", "$location", "CurrentCampaign", "AppConstants", "CTServiceAPIConfig", "DataService", function($route, $location, CurrentCampaign, AppConstants, CTServiceAPIConfig, DataService) {
    const _controller = this;

    _controller.campaign = false;

    _controller.isLoaded = () => !!_controller.campaign;

    // Flag Goal is reached
    _controller.goalReached = false;
    _controller.goal = {};

    _controller.getHeaderClasses = () => {
        if(!_controller.isLoaded()) return;

        return {
            'ct-gr-detail-header--has-image': _controller.campaign.hasImage()
        };
    };

    _controller.getHeaderStyles = () => {

        if(!_controller.isLoaded()) return;
        var styles = {};
        if(_controller.campaign.hasImage()) {
            styles.backgroundImage = `url('${_controller.campaign.image.original}')`;
        }

        return styles;
    };

    /**
     * Checks if Goal is enabled
     * @returns {*}
     */
    _controller.hasGoal = () => {

        if (!_controller.isLoaded()) return;

        _controller.goal = {
            target: _controller.campaign.goal,
            actualCount:  _controller.campaign.membercount

        };
        return _controller.campaign.goal_enabled;
    };

    /**
     * Calculates the Progressbar of the Goal if enabled
     * @returns {{width: string}}
     */
    _controller.calculateGoalStyles = () => {

        if (!_controller.isLoaded()) return;

        let styles = {
            width: '0%'
        },
            c = _controller.campaign,
            percentage = 0;

        /**
         * Do Calculation if there is a goal
         */
        if(c.goal_enabled) {
            // has the Goal been already reached
            _controller.goalReached = (c.membercount >= c.goal);

            // Calculate Percentage and set the WIdth of the Bar
            percentage = (c.membercount / c.goal) * 100;
            styles.width = `${percentage}%`;
        }

        return styles;
    };

    _controller.getAuthor = () => _controller.campaign.person;

    /**
     * get the share url, which is the current url without the query string
     *
     * @returns {string}
     */
    _controller.getShareURL = () => `${CTServiceAPIConfig.HOST}/api/v1/pages/${AppConstants.PAGE_ID}/grassroot_campaigns/${_controller.campaign.id}/share?redirect_url=${encodeURIComponent(location.href.split("?")[0])}`;

    (function init() {
        CurrentCampaign.get()
                       .then((campaign) => (_controller.campaign = campaign))
                       .then(null, () => $location.path('/'));
    }());
}];
